import Text from "shared/components/data-display/mui/Text";
import styled from "styled-components";

export const NavLinkText = styled(Text)`
    width: fit-content;
    border-bottom: ${({ $active }) =>
        $active ? globalThis.config.border.large : ""};
`;
